/**
 * Operational settings for the customer app (currency, hours, fees, booking rules …) from
 * GET /api/settings/public. Never hardcode these values in the UI.
 */
import { useEffect, useState } from 'react'
import { API_BASE_URL } from '../config/api'

let cache = null
let pending = null

export function loadPublicSettings() {
  if (cache) return Promise.resolve(cache)
  pending ??= fetch(`${API_BASE_URL}/api/settings/public`).then(r => r.json()).then(s => (cache = s)).finally(() => { pending = null })
  return pending
}

export function usePublicSettings() {
  const [settings, setSettings] = useState(cache)
  useEffect(() => { if (!cache) loadPublicSettings().then(setSettings).catch(() => setSettings({})) }, [])
  return settings
}

/**
 * Money formatter. Currency: opts.currency when given (the currency an API response carries, e.g. a quote),
 * else the market currency (setting market.currency).
 */
export function useMoney() {
  const s = usePublicSettings()
  const marketCurrency = s?.['market.currency']
  return (amount, { currency: given, ...opts } = {}) => {
    if (amount === null || amount === undefined || amount === '' || Number.isNaN(Number(amount))) return '—'
    const currency = given || marketCurrency
    if (!currency) return Number(amount).toLocaleString()
    return new Intl.NumberFormat(undefined, { style: 'currency', currency, maximumFractionDigits: 2, ...opts }).format(Number(amount))
  }
}
